

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { TeamsSetup } from "../../components/TeamsSetup/TeamsSetup";


export const TeamsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Teams Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Teams", navigateTo: "/company/teams/list" },
        { text: "Create Teams", navigateTo: "/company/teams/setup" }
      ]}
      mainContents={<TeamsSetup />}
    />
  );
};
